import { render, staticRenderFns } from "./ColdChainEditor.vue?vue&type=template&id=251cad8a"
import script from "./ColdChainEditor.vue?vue&type=script&lang=js"
export * from "./ColdChainEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports